/* Herbaris 2026 collection pages: the price amounts under the slider follow
   the handles while they move. The filters form is re-rendered after every
   change, so the listener sits on the document. */
(() => {
  const format = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n)) return value;
    return `${n.toFixed(2).replace('.', ',').replace(',00', '')} lei`;
  };

  document.addEventListener('input', (event) => {
    const range = event.target.closest('.f-facets-price__range');
    if (!range) return;
    const box = range.closest('price-range');
    if (!box) return;
    const min = box.querySelector('[data-type="min-range"]');
    const max = box.querySelector('[data-type="max-range"]');
    const minLabel = box.querySelector('[data-hb-price-label="min"]');
    const maxLabel = box.querySelector('[data-hb-price-label="max"]');
    if (min && minLabel) minLabel.textContent = format(min.value);
    if (max && maxLabel) maxLabel.textContent = format(max.value);
  });
})();

/* Mobile: the sort pill sits outside the filter drawer, and on phones the
   theme only sends the form that changed, which would drop the active
   filters. Hand the choice to the drawer's own (hidden) sort field instead,
   so filters and sort go out together. */
(() => {
  const relay = (event) => {
    const select = event.target;
    if (!select || select.id !== 'SortBy') return;
    if (!(window.FoxThemeSettings && window.FoxThemeSettings.isMobile)) return;
    const drawerSort = document.getElementById('Mobile-SortBy');
    if (!drawerSort) return;
    event.stopPropagation();
    if (event.type !== 'input') return;
    drawerSort.value = select.value;
    drawerSort.dispatchEvent(new Event('input', { bubbles: true }));
  };
  window.addEventListener('input', relay, true);
  window.addEventListener('change', relay, true);
})();
